export default "/assets/copy-meal.svg";